export default __webpack_public_path__ + "static/storycard-ddec3c8ce2b04640208cdb82a0587e19.png";